export default __webpack_public_path__ + "static/src/assets/images/icons/nav_search_icon_watchlist_hit.png";